import { useInsertionEffect } from 'react';

import { Container } from '@/atoms';
import { BackgroundVideoText as VideoText } from '@/organisms';

import { backgroundVideoTextTransformer } from '@/lib/graphql/transformers';

/**
 * BackgroundVideoText
 */
export const BackgroundVideoText = ({ bloque, id, className }: any) => {
  useInsertionEffect(() => {
    const style = document.createElement('style');

    // ACF returns the value 0 as null
    let mobile_padding_top = bloque?.paddingTop || 0;
    let mobile_padding_bottom = bloque?.paddingBottom || 0;

    if (mobile_padding_top === 0) {
      mobile_padding_top = 0;
    } else {
      mobile_padding_top = Math.round(mobile_padding_top * 0.5);
    }

    if (mobile_padding_bottom === 0) {
      mobile_padding_bottom = 0;
    } else {
      mobile_padding_bottom = Math.round(mobile_padding_bottom * 0.5);
    }

    style.textContent = `
      .background-video-text-${id}-padding {
        padding-top: ${mobile_padding_top}px;
        padding-bottom: ${mobile_padding_bottom}px;
      }

      @media (min-width: 768px) {
        .background-video-text-${id}-padding {
          padding-top: ${bloque?.paddingTop || 0}px;
          padding-bottom: ${bloque?.paddingBottom || 0}px;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Container
      id={id}
      as="section"
      padding=""
      className={`background-video-text-${id}-padding ${className}`}
    >
      <VideoText {...backgroundVideoTextTransformer(bloque)} />
    </Container>
  );
};

BackgroundVideoText.displayName = 'BackgroundVideoText';
